// extracted by mini-css-extract-plugin
export default {"titleDiv":"bigOneWithDot_titleDiv__wIWu0"};